export default __webpack_public_path__ + "static/media/ic_malaysia.99cbe3b7.svg";